<template>
    <div>
        <header class="mb-8">
            <p class="nl-eyebrow flex items-center gap-2"><span class="h-1.5 w-1.5 rounded-full bg-nomad-red"></span>Local news</p>
            <h1 class="nl-title mt-2 text-3xl md:text-5xl">News</h1>
            <p class="mt-2 text-nomad-300">Local &amp; diaspora stories</p>
        </header>
        <div class="grid grid-cols-12 gap-8">
            <div class="col-span-12 flex flex-col gap-3 lg:col-span-8">
                <div v-for="(story, index) in stories.data" :key="story.id">
                    <AdSlot v-if="index === 3" placement="article" class="mb-3" />
                    <article class="nl-card overflow-hidden" v-if="index == 0">
                        <Link v-if="story.image" :href="'/story/' + story.id" class="block overflow-hidden">
                            <img :src="story.image" :alt="story.title" class="aspect-[16/9] w-full object-cover transition-transform duration-700 hover:scale-[1.02]" />
                        </Link>
                        <div class="flex flex-col gap-3 p-6">
                            <span class="nl-eyebrow !text-nomad-300">{{ story.source.name }}</span>
                            <h3 class="font-display text-2xl font-semibold leading-tight text-white lg:text-3xl">
                                <Link :href="'/story/' + story.id" class="transition-colors hover:text-nomad-accent"><span v-html="story.title"></span></Link>
                            </h3>
                            <div class="text-sm text-nomad-400"><span class="hidden lg:inline" v-if="story.author">{{ story.author }} · </span><span>{{ story.published_at }}</span></div>
                        </div>
                    </article>
                    <article class="nl-card grid grid-cols-12 items-center gap-4 p-4" v-else>
                        <div class="col-span-8 flex flex-col gap-2">
                            <span class="text-[0.6875rem] font-semibold uppercase tracking-[0.16em] text-nomad-400">{{ story.source.name }}</span>
                            <h3 class="font-semibold leading-snug text-white lg:text-lg">
                                <Link :href="'/story/' + story.id" class="transition-colors hover:text-nomad-accent">{{ story.title }}</Link>
                            </h3>
                            <div class="text-xs text-nomad-400"><span class="hidden lg:inline" v-if="story.author">{{ story.author }} · </span><span>{{ story.published_at }}</span></div>
                        </div>
                        <div class="col-span-4" v-if="story.image">
                            <Link :href="'/story/' + story.id"><img :src="story.image" :alt="story.title" loading="lazy" class="aspect-[4/3] w-full rounded-xl object-cover" /></Link>
                        </div>
                    </article>
                </div>
            </div>
            <div class="col-span-12 lg:col-span-4">
            </div>
        </div>
    </div>
</template>
<script setup>
import { Link, usePage, router } from "@inertiajs/vue3";
const { stories } = usePage().props;
</script>
<script>
import AdSlot from "@/components/ui/AdSlot.vue";
import { defineAsyncComponent } from 'vue'
export default {
    components: {
        AdSlot,
    }
}
</script>